'use client'

import React from 'react'
import styles from './styles.module.css'
import SaleCountdown from '../../../SaleCampaign/SaleCountdown'
import useSaleClock from '../../../SaleCampaign/useSaleClock'
import {
  getLimitedDealForItem, getLimitedDealState, getSaleBonus, isItemInSale, hasBackendDiscount, msOf, dealEndMs, DEAL_LIVE, DEAL_SOLD_OUT,
} from '../../../../lib/saleCampaign'
import { itemTypeOf } from '../saleFormat'
import SaleBonusPill from '../../../SaleCampaign/SaleBonusPill'

// Product-page strip under the price for the SELECTED option. An option is a
// list of items (the 3-pedal set option = Throttle & Brake + Clutch), so:
//  - one item on a running limited deal -> "Limited time offer", countdown to the deal end
//  - one item whose deal sold out       -> "Deal sold out", countdown to the sale end
//  - any item in the sale               -> "<sale> price", countdown to the sale end
// Same honesty rule as the shop pill: only items the backend prices below
// regular count. The sale's free extra (getSaleBonus, e.g. 3 months of VRS
// Competitive) is a separate line, and on its own for products not in the sale.
// Renders nothing outside the sale.
function SaleProductBadge({ campaign, saleNowMs, saleClockOffsetMs, region, items }) {
  const { nowMs, mounted } = useSaleClock(saleNowMs, saleClockOffsetMs)
  if (!campaign || !Array.isArray(items) || !items.length) return null
  const onSale = items.filter((i) => i && isItemInSale(campaign, nowMs, region, itemTypeOf(i)) && hasBackendDiscount(i))
  const bonus = getSaleBonus(campaign, nowMs, region, itemTypeOf(items[0]))
  const bonusLine = bonus && (
    <span className={styles.bonus}><SaleBonusPill bonus={bonus} theme="dark"/></span>
  )
  if (!onSale.length) {
    if (!bonus) return null
    return (
      <div className={[styles.badge, styles.sale].join(' ')}>
        <div className={styles.text}>
          <span className={styles.title}>{(campaign.product && campaign.product.bonusTitle) || 'Free with your order'}</span>
          {bonusLine}
        </div>
      </div>
    )
  }
  const deal = items.length === 1 ? getLimitedDealForItem(campaign, region, itemTypeOf(items[0])) : null
  const state = deal ? getLimitedDealState(campaign, nowMs, region, deal, items[0]) : null
  const limited = state === DEAL_LIVE
  const soldOut = state === DEAL_SOLD_OUT
  const copy = campaign.product || {}
  const units = deal && Number.isFinite(deal.units) ? String(deal.units) : 'a limited number of'
  let title = copy.saleTitle || `${campaign.shortName || campaign.name} price`
  let sub = copy.saleSub || 'Ends with the sale or when stock runs out.'
  if (limited) {
    title = copy.limitedTitle || 'Limited stock deal'
    sub = (copy.limitedSub || 'Only {units} units at this price.').replace('{units}', units)
  } else if (soldOut) {
    title = copy.soldOutTitle || 'Deal sold out'
    sub = copy.soldOutSub || 'The limited units are gone.'
  }
  return (
    <div className={[styles.badge, limited ? styles.limited : styles.sale].join(' ')}>
      <div className={styles.text}>
        <span className={styles.title}>{title}</span>
        <span className={styles.sub}>{sub}</span>
        {bonusLine}
      </div>
      <SaleCountdown targetMs={limited ? dealEndMs(campaign, deal) : msOf(campaign.end)} nowMs={nowMs} mounted={mounted} size="sm" theme={limited ? 'red' : 'dark'}/>
    </div>
  )
}

export default SaleProductBadge
